import { Auth } from "@icg360/ipc-auth-js";
import "loginCSS";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { LoginForm } from "./components/login/login-form";
import { LoginAside } from "./components/login/login-aside";
import { Messages } from "./components/messages";
import { MESSAGE_TYPES } from "./components/messages/constants";
import store from "./store/login-store";
import { addMessage } from "./store/messages";
import * as tracking from "./units/tracking";
import { read as readCookie } from "./utils/cookies";
import createRenderer from "./utils/create-renderer";
import { getApiUrl } from "./utils/get-api-url";
import getQueryParameters from "./utils/get-query-parameters";
import storage from "./utils/storage";
import {
  changeLoginFormView,
  sanitizeHash,
  submitLogin,
  submitForgotPassword,
  submitForgotUsername,
  handleSAMLPassthroughAuth,
  maintenanceMessage
} from "./utils/login";

const initialHash = window.location.hash;
const queryParams = getQueryParameters();
const supportPhoneHTML = ENV_INFO.supportPhone;
// eslint-disable-next-line testing-library/render-result-naming-convention
export const renderLoginForm = createRenderer(LoginForm, "login-form");

// expose login function for programmatic logins
// TODO remove this AFTER merge into master, if nothing breaks
// window.login = submitLogin;

// the login form, from LoginForm
renderLoginForm({
  view: initialHash.indexOf("#") === 0 ? initialHash.substring(1) : initialHash,
  onViewChange: changeLoginFormView,
  onLoginSubmit: submitLogin,
  onForgotPasswordSubmit: submitForgotPassword,
  onForgotUsernameSubmit: submitForgotUsername,
  supportPhoneHTML
});

// Login Menu - boxes on the right side of the login form
const LoginAsideRoot = createRoot(document.getElementById("login-aside"));
LoginAsideRoot.render(<LoginAside />);

// Alert messages for the login page
const MessagesRoot = createRoot(document.getElementById("messages"));
MessagesRoot.render(
  <Provider store={store}>
    <Messages />
  </Provider>
);

const loginMessage = storage.getItem("login-message");
if (loginMessage) {
  store.dispatch(
    addMessage({
      type: MESSAGE_TYPES.WARNING,
      text: loginMessage
    })
  );
  storage.removeItem("login-message");
}

if (queryParams.has("auth-session-uri")) {
  // handle SAML passthrough
  handleSAMLPassthroughAuth(queryParams.get("auth-session-uri"));
}

maintenanceMessage({
  message: CONFIG.envConfig.ipcm.values.maintenanceMessage,
  start: CONFIG.envConfig.ipcm.values.maintenanceStart,
  end: CONFIG.envConfig.ipcm.values.maintenanceEnd,
  lockout: CONFIG.envConfig.ipcm.values.maintenanceLockout
});

tracking.init(CONFIG.envConfig.mixpanel);
tracking.listen();
const client = new Auth({
  servicesUrl: getApiUrl("ixauth")
});

if (readCookie("apb64") || readCookie("auth-session-uri")) {
  client
    .identify()
    .then(res => {
      if (res && "identity" in res && res.identity && res.identity.id) {
        let redirectTo = `https://${window.location.host}/`;
        if (window.location.search) {
          const searchParams = new URLSearchParams(window.location.search);
          const redirectPath = searchParams.get("redirect");
          if (redirectPath) {
            redirectTo += `${
              redirectPath.startsWith("/")
                ? redirectPath.substring(1)
                : redirectPath
            }`;
            searchParams.delete("redirect");
          }
          // If we logged in through SAML, remove the relevant search params
          if (searchParams.get("auth-session-uri")) {
            searchParams.delete("auth-session-uri");
          }
          if (searchParams.get("saml-session-id")) {
            searchParams.delete("saml-session-id");
          }
          if (searchParams.size > 0) {
            // now construct the search params with what is left
            redirectTo += `?${searchParams.toString()}`;
          }
        } else if (window.location.hash) {
          redirectTo += `${sanitizeHash(window.location.hash)}`;
        }
        window.location.href = redirectTo;
      }
    })
    .catch(() => undefined);
}
